import { ShieldAlert, ShieldCheck, MessageCircle } from "lucide-react";

const NOT_LIST = [
  "delivery company",
  "food-delivery app",
  "courier service",
  "maid agency",
  "domestic-worker platform",
  "rider / delivery-boy network",
  "employment agency",
];

const IS_LIST = [
  "Human-to-Human Help Sharing",
  "India's first & last help network",
  "Free and paid — no hidden middleman",
  "KYC-verified helpers, matched by service & location",
  "HeylpMate talks to both sides before we connect",
];

export default function WhatWeAre() {
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-8 pt-24 md:pt-32">
      <span className="label-eyebrow">the honest positioning</span>
      <h2 className="mt-3 font-display text-4xl md:text-5xl font-bold leading-tight max-w-3xl">
        HeylpMate is <span className="italic" style={{ color: "var(--secondary)" }}>not</span> what you think.
      </h2>
      <p className="mt-4 max-w-2xl" style={{ color: "var(--text-muted)" }}>
        We're a Human-to-Human help network — real people helping real people. Not another gig-worker aggregator.
      </p>

      <div className="grid md:grid-cols-2 gap-4 mt-10">
        <div className="rounded-3xl border-2 border-red-100 bg-red-50/50 p-7">
          <div className="flex items-center gap-2 text-red-700">
            <ShieldAlert className="w-5 h-5" />
            <span className="text-xs uppercase tracking-widest font-bold">HeylpMate is NOT</span>
          </div>
          <ul className="mt-4 space-y-2">
            {NOT_LIST.map((x) => (
              <li key={x} className="flex items-center gap-2 text-sm text-neutral-700">
                <span className="text-red-500 text-lg leading-none">×</span> {x}
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-3xl border-2 p-7 text-white" style={{ background: "var(--primary)", borderColor: "var(--primary)" }}>
          <div className="flex items-center gap-2" style={{ color: "var(--secondary)" }}>
            <ShieldCheck className="w-5 h-5" />
            <span className="text-xs uppercase tracking-widest font-bold">HeylpMate IS</span>
          </div>
          <ul className="mt-4 space-y-2">
            {IS_LIST.map((x) => (
              <li key={x} className="flex items-center gap-2 text-sm">
                <span className="text-lg leading-none" style={{ color: "var(--secondary)" }}>✓</span> {x}
              </li>
            ))}
          </ul>
          <div className="mt-5 flex items-center gap-2 text-xs text-white/70">
            <MessageCircle className="w-3.5 h-3.5" /> Human check on both sides · always
          </div>
        </div>
      </div>
    </section>
  );
}
